// Injury report tag for pick lists: red when ruled out, orange when questionable, yellow when probable.
const OUT = /^(out|doubtful|injured reserve|ir|suspension|physically unable)/i;

export const injuryTone = (status) => {
  const s = String(status || '');
  if (OUT.test(s)) return 'bg-red-600 text-white';
  if (/probable/i.test(s)) return 'bg-yellow-400 text-black';
  return 'bg-orange-500 text-black';
};

export const isRuledOut = (injury) => OUT.test(String(injury?.status || ''));

export const InjuryTag = ({ injury, testId, withDetail = false }) => {
  if (!injury?.status) return null;
  const out = isRuledOut(injury);
  const label = `${String(injury.status).toUpperCase()}${out ? ' — NOT PLAYING' : ''}`;
  return (
    <span className={`inline-block whitespace-nowrap rounded px-1 align-middle text-[9px] font-black leading-4 ${injuryTone(injury.status)}`}
      title={injury.detail || label} data-testid={testId}>
      {label}{withDetail && injury.detail ? ` · ${injury.detail}` : ''}
    </span>
  );
};
